<template>
  <div class="section">
    <div class="container">
      <div class="has-text-centered">
        <p>
          You must agree to the terms and conditions before continuing.
        </p>
        <div>
          <b-checkbox v-model="agree"></b-checkbox>Agree to <a @click="OpenModal">Terms and Conditions</a>
        </div>
        <b-button type="is-success" style="margin-top:2em" :disabled="!agree" :loading="agreeing" @click="Agree">I Agree</b-button>
      </div>
    </div>
  </div>
</template>
<script>
  import termsAndConditions from '@/components/modals/termsAndConditions.vue';
  export default {
    data() {
      return {
        agree: false,
        agreeing: false
      }
    },
    methods: {
      OpenModal() {
        this.$buefy.modal.open({
          parent: this,
          component: termsAndConditions,
          hasModalCard: true,
        })
      },
      async Agree() {
        this.agreeing = true;
        try {
          await this.$http.get("/api/user/agree");
          await this.$refresh();
          this.$router.push("/index");
        }
        catch (err) {
          this.agreeing = false;
          this.$buefy.notification.open({
            duration: 4000,
            message: "You must be logged in.",
            type: 'is-danger',
          });
          console.error(err);
          return Promise.reject(err);
        }
      }
    }
  }
</script>
